import { render, staticRenderFns } from "./ModalLabel.vue?vue&type=template&id=512f2a9a&scoped=true&lang=pug"
import script from "./ModalLabel.vue?vue&type=script&lang=js"
export * from "./ModalLabel.vue?vue&type=script&lang=js"
import style0 from "./ModalLabel.vue?vue&type=style&index=0&id=512f2a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512f2a9a",
  null
  
)

export default component.exports